import React, { useState, useEffect } from 'react';
import {
  isValidEmail,
  mapPayloadForRequestQuote,
  mapPayloadForRequestQuoteMultileg,
} from '../../../utils/helper';
import { useShipForm } from '../../../context/shipForms';
import { requestQuoteEmail } from '../../../api/shipmentForms';
import { ContactDto, ReferenceRouteFormDto } from '../../../types';
import UbbeModalHeader from '../../global-components/modalHeader';
interface Props {
  setOpenModal: any;
  legIndex?: number;
}
function RequestQuoteModal({ setOpenModal, legIndex }: Props) {
  const {
    getRatesApiPayloadContext,
    setRatesApiPayloadContext,
    getShipperFormData,
    getConsigneeFormData,
    getReferenceFormDataContext,
    getAddLegShipmentDataContext,
    getAddLegShipmentPackagesContext,
    getMultiLegListContext,
  } = useShipForm();
  const initialRatesPayload: any = getRatesApiPayloadContext();
  const shipperFormData: ContactDto = getShipperFormData();
  const consigneeFormData: ContactDto = getConsigneeFormData();
  const addLegShipmentDataContext: any = getAddLegShipmentDataContext();
  const addLegShipmentPackagesContext: any = getAddLegShipmentPackagesContext();
  const multiLegListContext: any = getMultiLegListContext();
  const referenceFormContextData: ReferenceRouteFormDto =
    getReferenceFormDataContext();

  const [ratesPayload, setRatesPayload] = useState({
    ...initialRatesPayload,
    quote_email: '',
  });

  const [loading, setLoading] = useState(false);
  const [validating, setValidating] = useState(false);

  useEffect(() => {
    setRatesPayload((prev: any) => ({
      ...prev,
      quote_email: '',
    }));
  }, []);

  function submitRequest() {
    setValidating(true);
    if (isValidEmail(ratesPayload?.quote_email)) {
      setRatesApiPayloadContext(ratesPayload);
      let payload;
      if (typeof legIndex !== 'undefined') {
        payload = mapPayloadForRequestQuoteMultileg(
          addLegShipmentDataContext,
          addLegShipmentPackagesContext,
          multiLegListContext,
          ratesPayload,
          legIndex
        );
      } else {
        payload = mapPayloadForRequestQuote(
          ratesPayload,
          shipperFormData,
          consigneeFormData,
          referenceFormContextData
        );
      }

      if (payload) {
        setLoading(true);
        requestQuoteEmail(payload)
          .then((response) => {
            if (response?.data?.is_error === false) {
              setValidating(false);
              setLoading(false);
              setRatesPayload((prev: any) => ({
                ...prev,
                quote_email: '',
              }));
              setOpenModal(false);
            }
          })
          .catch((e) => {
            setLoading(false);
          });
      }
    }
  }

  function handleCloseModal() {
    setRatesPayload((prev: any) => ({
      ...prev,
      quote_email: '',
    }));
    setOpenModal(false);
  }

  return (
    <div
      className='modal fade show'
      id='bbe_quote_modal'
      tabIndex={-1}
      role='dialog'
      aria-labelledby='quoteModalLabel'
      style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
    >
      {loading && (
        <div className='loader-container'>
          <div className='spinner'></div>
        </div>
      )}
      <div
        className='modal-dialog modal-dialog-centered modal-md'
        role='document'
      >
        <div className='modal-content'>
          <UbbeModalHeader
            headerText='Quote Request'
            onClose={handleCloseModal}
          />
          <div className='modal-body p-4'>
            <div>
              <div className='text-center'>
                <div className='fw-bold'>Apologies for the delay!</div> Please
                enter your email for a quote within 24 hours. For immediate
                assistance, call “1-888-420-6926” & select option “1”
              </div>
            </div>

            <div className='row mb-3'>
              <label
                className='col-sm-12 col-form-label fw-bold my-auto'
                htmlFor='bbe_quote_email'
              >
                Email Address
                <span
                  className='text-danger fw-bold'
                  style={{ marginLeft: '2px' }}
                >
                  *
                </span>
              </label>
              <div className='col-sm-12'>
                <input
                  id='bbe_quote_email'
                  className='form-control ubbe-input'
                  maxLength={100}
                  autoComplete='new-password'
                  value={ratesPayload?.quote_email || ''}
                  onChange={(e) => {
                    setRatesPayload({
                      ...ratesPayload,
                      quote_email: e.target.value,
                    });
                  }}
                  placeholder='email@email.com'
                />
                {validating && !isValidEmail(ratesPayload?.quote_email) && (
                  <div className='error_text' id='bbe_quote_email_error'>
                    Please provide a valid email.
                  </div>
                )}
              </div>
            </div>
            <div className='d-flex py-2 flex-column justify-content-center'>
              <p
                className='btn m-auto ubbe-blue-bg p-2 px-4 rounded-3 text-light'
                onClick={submitRequest}
                style={{
                  width: 'max-content',
                  backgroundColor: '#251163',
                  fontFamily: 'Lexend',
                }}
              >
                Send
              </p>
              <u
                className='m-auto mt-2 d-flex justify-content-center labelText'
                style={{ cursor: 'pointer' }}
                onClick={handleCloseModal}
              >
                Close
              </u>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RequestQuoteModal;
